import Address from './address';
import Business from './business';
import General from './general';
import Menu from './menu';

export default {
  Address,
  Business,
  General,
  Menu,
};
